<template>
  <div>
    <div id="overtime"></div>
  </div>
</template>
  
  
<script>
import * as echarts from "echarts/core";
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent,
]);

export default {
  props: {
    list: {
      type: Array,
    },
  },

  watch: {
    list: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },

  mounted() {
    var chartDom = document.getElementById("overtime");
    chartDom.style.height = "50vh";
    chartDom.style.width = "100%";
    this.chart = echarts.init(chartDom);
    this.renderChart();
  },

  destroyed() {
    this.chart?.dispose();
  },

  methods: {
    renderChart() {
      if (!Array.isArray(this.list)) return;

      this.chart?.clear();

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          valueFormatter: (value) => value,
        },

        legend: {
          show: true,
          left: "center",
          top: "bottom",
          textStyle: {
            // color: "#fff",
          },
        },

        grid: {
          show: false,
          left: "4%",
          top: "5%",
          bottom: "45%",
          right: "0%",
        },

        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#999",
            rotate: 45,
          },
          data: this.list.map((item) => item.name),
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: "#999",
              type: "dashed",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#999",
            },
          },
          axisLabel: {
            color: "#999",
            formatter: "{value}",
          },
        },

        series: [
          {
            name: "考勤人数",
            type: "bar",
            // barWidth: "15px",
            data: this.list.map((item) => item.userSum),
          },
          {
            name: "加班人数",
            type: "bar",
            // barWidth: "15px",
            data: this.list.map((item) => item.overtimeUserCount),
          },
        ],
      };

      option && this.chart.setOption(option);
    },
  },
};
</script>